import React, { useState, useEffect } from "react";
import Calendar from "react-calendar";
//import "./styles.css";
import { Row, Col, Form, Button, Modal } from "react-bootstrap";
// import LeftpanelMember from "../../../components/leftpanel/left-panel-admin";
// import HeaderPart from "../../../components/layout/header-admin/header";
import "./calendar-events.css";
import { Image } from "../../../assets/images";
import axios from "../../../axios/axios";
import { message } from "antd";
import LoadingOverlay from "react-loading-overlay";
import { adminConfig } from "../../../utils/adminConfig";

const CalendarEvents = () => {
  const [value, onChange] = useState(new Date());
  const [cals, setCals] = useState([]);
  const [file, setFile] = useState("");
  const [loading, setLoading] = useState(false);
  const [isTripValet, setTRP] = useState(false);
  const [isTripValetIncentive, setTVI] = useState(false);

  const [show, setShow] = useState(false);
  const [calId, setCalId] = useState("");

  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);

  const addCalendar = (e) => {
    e.preventDefault();

    setLoading(true);
    let data = new FormData();

    if (file) {
      data.append("image", file);
      data.append("date", value);
      data.append("isTripValet", isTripValet);
      data.append("isTripValetIncentive", isTripValetIncentive);

      axios
        .post(`/add-calendar`, data, adminConfig())
        .then((res) => {
          if (res.data.status === true) {
            message.success("added certificate success");
            getCalendars();
          } else {
            message.error("failed adding certificates");
          }
        })
        .catch((err) => {
          console.log(err);
        });
      setLoading(false);
    } else {
      message.error("file not found");
    }
  };
  const getCalendars = async () => {
    setLoading(true);
    axios
      .get(`/get-calendar`, adminConfig())
      .then((res) => {
        if (res.data.status === true) {
          // message.success("fetched calendar success");
          setCals(res.data.data);
          // setPagination(res.data.pagination);
          setLoading(false);
        } else {
          message.error("Data Not Found");
          setLoading(false);
        }
      })
      .catch((err) => {
        console.log(err);
        setLoading(false);
      });
  };

  useEffect(() => {
    getCalendars();
  }, []);

  const deleteCal = async () => {
    handleClose();

    let data = { _id: calId };
    setLoading(true);
    axios
      .post(`/delete-calendar`, data, adminConfig())
      .then((res) => {
        if (res.data.status === true) {
          message.success("delete calendar success");
          getCalendars();
          // setCals(res.data.data);
          // setPagination(res.data.pagination);
          setLoading(false);
        } else {
          message.error("failed fetching calendar");
          setLoading(false);
        }
      })
      .catch((err) => {
        setLoading(false);

        console.log(err);
      });
  };
  return (
    // <div>
    //     <HeaderPart />
    //     <div className='main_cont'>
    //         <LeftpanelMember />
    <LoadingOverlay active={loading} spinner text="loading...">
      <div className="right_cont">
        <div className="right_banner_banner_cnt">
          <div className="travel_deals_admin">
            <h2>Hello, Admin!</h2>
            <div className="calendar_events">
              <h4>Pick a date</h4>
              <Calendar onChange={onChange} value={value} />
            </div>
            <div className="add_certificate">
              <h3>Upload Image</h3>
              <div className="addcert_box1">
                <Row>
                  <Col lg="12" md="12" sm="12">
                    <Form.Group className="mb-3" controlId="formBasicEmail">
                      {/* <Form.Control
                                                as="select"
                                                custom
                                                className='text_link bulk_select'
                                                >
                                                <option>Select</option>
                                                <option>CSV</option>
                                                <option>Green</option>
                                                <option>Black</option>
                                                <option>Orange</option>
                                            </Form.Control> */}
                      <div className="upload_btn_wrapper">
                        <button className="btn_bulk">
                          <span className="cert_bulkks">
                            <img src={Image} alt="" />
                          </span>
                          {file ? (
                            file.name
                          ) : (
                            <>
                              Upload Image
                              <input
                                type="file"
                                name="myfile"
                                onChange={(e) => {
                                  // console.log(e.target.files[0]);
                                  setFile(e.target.files[0]);
                                }}
                              />
                            </>
                          )}
                        </button>
                      </div>
                    </Form.Group>
                    <h2>Select Domain</h2>
                    <div className="d-flex mt-2">
                      <div className="form_group px-3">
                        <input
                          type="checkbox"
                          id="html"
                          checked={isTripValet}
                          onChange={(e) => setTRP(!isTripValet)}
                        />
                        <label for="html">Tripvalet</label>
                      </div>
                      <div className="form_group px-3">
                        <input
                          type="checkbox"
                          id="css"
                          checked={isTripValetIncentive}
                          onChange={(e) => setTVI(!isTripValetIncentive)}
                        />
                        <label for="css">Tripvalet Incentive</label>
                      </div>
                    </div>
                    <div className="sub_but">
                      <button
                        type="button"
                        onClick={addCalendar}
                        className="add_but submit_buttt mt-0"
                      >
                        Submit
                      </button>
                    </div>
                  </Col>
                </Row>
              </div>
            </div>

            <div className="image_gallery">
              <h2>Image Gallery</h2>
              <div className="gallery_inner">
                {cals.length > 0 &&
                  cals.map((cal) => {
                    return (
                      <div className="gallery_inner_inner">
                        <div className="gallery_box">
                          <a
                            href={cal.calendarImg}
                            target="_blank"
                            rel="noreferrer"
                          >
                            <img
                              src={cal.calendarImg}
                              // onClick={deleteCal(cal._id)}
                              alt=""
                            />
                          </a>
                          <a
                            className="cross_but"
                            href="#/"
                            onClick={() => {
                              setCalId(cal._id);
                              handleShow();
                            }}
                          >
                            X
                          </a>
                          <div className="domain_name">
                            <p>
                              <span>{cal.month}</span>
                              <span>{cal.year}</span>
                              {cal.isTripValet && <p>Tripvalet</p>}
                              {cal.isTripValetIncentive && (
                                <p>TripValetIncentive</p>
                              )}
                            </p>
                          </div>
                        </div>

                        {/* <span>{cal.date}</span> */}
                      </div>
                    );
                  })}

                {/* <div className="gallery_inner_inner">
                  <div className="gallery_box">
                    <img src={Trip} />
                  </div>
                </div>

                <div className="gallery_inner_inner">
                  <div className="gallery_box">
                    <img src={Trip} />
                  </div>
                </div> */}

                {/* <div className="gallery_inner_inner">
                  <div className="gallery_box">
                    <img src={Trip} />
                  </div>
                </div>

                <div className="gallery_inner_inner">
                  <div className="gallery_box">
                    <img src={Trip} />
                  </div>
                </div>

                <div className="gallery_inner_inner">
                  <div className="gallery_box">
                    <img src={Trip} />
                  </div>
                </div> */}
              </div>
            </div>
          </div>
          <Modal show={show} onHide={handleClose}>
            {/* <Modal.Header closeButton>
        </Modal.Header> */}
            <Modal.Body>
              <h4 className="text-center">Are you sure you want to delete?</h4>
              <div className="yes_no_but d-flex align-items-center justify-content-center">
                <Button
                  variant="secondary"
                  className="yes_but"
                  onClick={deleteCal}
                >
                  Yes
                </Button>
                <Button
                  variant="primary"
                  className="no_but"
                  onClick={handleClose}
                >
                  No
                </Button>
              </div>
            </Modal.Body>
            {/* <Modal.Footer>
          
        </Modal.Footer> */}
          </Modal>
        </div>
      </div>
    </LoadingOverlay>
    //     </div>
    // </div>
  );
};

export default CalendarEvents;
